import axios from "axios"
const API_URL = process.env.REACT_APP_API_URL;

/**
 * Create or retrieve the current user's admin support chat conversation.
 */
export const createOrGetAdminConversation = async (token) => {
    try {
        const response = await axios.post(`${API_URL}/admin-chat/conversation`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        if (response.status >= 200 && response.status < 300) {
            const conversation = response.data.data || response.data
            return { success: true, data: conversation }
        }
        return { success: false, error: "Failed to create or get admin conversation" }
    } catch (err) {
        console.error('Failed to create or get admin conversation: ', err)
        return { success: false, error: err.message }
    }
}

/**
 * Get messages for an admin support chat conversation.
 */
export const getAdminChatMessages = async (token, conversationId) => {
    try {
        const response = await axios.get(`${API_URL}/admin-chat/messages/${conversationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data.data || response.data }
        }
        return { success: false, error: "Failed to get admin chat messages" }
    } catch (err) {
        console.error('Failed to get admin chat messages: ', err)
        return { success: false, error: err.message }
    }
}

/**
 * Send a TEXT message in an admin support chat conversation.
 * obj: { conversationId, message, messageType }
 */
export const sendAdminChatMessage = async (token, obj) => {
    try {
        const response = await axios.post(`${API_URL}/admin-chat/message`, obj, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data.data || response.data }
        }
        return { success: false, error: "Failed to send message" }
    } catch (err) {
        console.error('Error sending admin chat message: ', err)
        return { success: false, error: err.message }
    }
}

/**
 * Get total unread admin support chat message count.
 */
export const getAdminUnreadCount = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/admin-chat/unread-count`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        if (response.status >= 200 && response.status < 300 && response.data.success) {
            return { success: true, unread: response.data.data.unreadCount }
        }
        return { success: false }
    } catch (err) {
        console.error('Error getting admin unread count: ', err)
        return { success: false, error: err.message }
    }
}

/**
 * Upload a file/image/audio attachment for admin support chat.
 * This single authenticated call uploads to Cloudinary via the backend,
 * creates the chat message, and emits the real-time socket event —
 * all server-side, in one request.
 * formData must include: 'file', 'conversationId', and optionally 'message'.
 */
export const uploadAdminChatFile = async (token, formData) => {
    try {
        const response = await axios.post(`${API_URL}/upload/admin-chat`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data.data }
        }
        return { success: false, error: "Failed to upload file" }
    } catch (err) {
        console.error('Error uploading admin chat file: ', err)
        return { success: false, error: err.message }
    }
}
